import {Field, useFormikContext} from 'formik';

import {Grid, Input, Text} from '@mantine/core';

import {
    FormikTextInput
} from '@flexinet/ui-components';
import {User} from '../../types';

export const PersonalPanel = () => {
    const {values} = useFormikContext<User>();

    return (
        <Grid p={'sm'} my={'sm'}>

            <Grid.Col span={12}>
                <Field
                    name='name'
                    label='Name'
                    description='Optional display name'
                    component={FormikTextInput}
                />
            </Grid.Col>

            <Grid.Col span={6}>
                <Field
                    name='givenName'
                    label='Given Name'
                    description='Please enter given name'
                    component={FormikTextInput}
                    withAsterisk
                />
            </Grid.Col>

            <Grid.Col span={6}>
                <Field
                    name='familyName'
                    label='Family Name'
                    description='Please enter family name'
                    component={FormikTextInput}
                    withAsterisk
                />
            </Grid.Col>

            <Grid.Col span={6}>
                <Field
                    name='email'
                    label='Email'
                    description='Please enter email'
                    component={FormikTextInput}
                    withAsterisk
                />
            </Grid.Col>

            <Grid.Col span={6}>
                {/* Read-only (FNP-2015). users-api returns the STRING "false", which
                    a switch reads as on, and Directory never sends this field. */}
                <Input.Wrapper label='Email Verified'>
                    <Text>{values.emailVerified === 'true' ? 'Yes' : 'No'}</Text>
                </Input.Wrapper>
            </Grid.Col>

            <Grid.Col span={6}>
                <Field
                    name='middleName'
                    label='Middle Name'
                    description='Please enter middleName'
                    component={FormikTextInput}
                />
            </Grid.Col>


        </Grid>)

};